module.exports = __webpack_public_path__ + "img/rachael.2953c85c.png";